import { render, staticRenderFns } from "./InputTextIdentikit.vue?vue&type=template&id=34765cd6"
import script from "./InputTextIdentikit.vue?vue&type=script&lang=js"
export * from "./InputTextIdentikit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports